import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import getKhattabat101MatchStore from "../../../../../stores/khattabat-stores/101m-stores";
import MarkAsReadButton from "../../../khattabat-clients/conversation/body/side-actions/MarkAsReadButton";
import EnableDisableConversation from "../../shared/EnableDisableConversation";
import HighlightOneOOneM from "../../shared/HighlightOneOOneM";
import IgnoreConversation from "../../shared/IgnoreConversation";
import SendSlackAlertsOneOOneM from "../../shared/SendSlackALerts";

const SideActions = withLiteObserverAndTheme<{
  matchID: number;
}>((props) => {
  const { matchID, theme } = props;
  const { unitY, colors } = theme;

  const {
    matchStatus,
    matchHasDeletedTheConversation,
    hasOneOTwoWithClient,
    conversationID
  } = getKhattabat101MatchStore(matchID);

  const isActiveMatch = matchStatus.get() === "active";
  const statusColor = isActiveMatch ? colors.all.green : colors.all.red;

  return (
    <ET3Div
      width={200}
      height={200}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      {!matchHasDeletedTheConversation.get() ? null : (
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={20}
          isSpan={true}
          text={i18n.get("DELETED_BY_MATCH")}
          style={{
            height: 30 * unitY,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            color: statusColor
          }}
          color={""}
        />
      )}
      <MarkAsReadButton
        userID={matchID}
        conversationID={conversationID.get()}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={20}
        isSpan={true}
        text={matchStatus.get()}
        style={{
          height: 30 * unitY,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          color: statusColor
        }}
        color={""}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <EnableDisableConversation matchID={matchID} />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <IgnoreConversation
        matchIDs={[matchID]}
        pageType={"matchResultPage"}
        hasOneOTwoWithClient={hasOneOTwoWithClient.get()}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <HighlightOneOOneM matchID={matchID} />
      <Et3Margin top={1} bottom={0} left={0} right={0} />
      <SendSlackAlertsOneOOneM matchID={matchID} />
    </ET3Div>
  );
});

export default SideActions;
